import { AddressContactViewModel } from 'viewModels/common/AddressContactViewModel';

export default class AddressBookItemContactListResponseViewModel {
  id: number;
  isDefault: boolean;
  contact: AddressContactViewModel;
}
